import React, {useEffect} from 'react'
import Container from '@mui/material/Container'
import { useAppDispatch, useAppSelector } from '../redux'

import 'react-notifications/lib/notifications.css'
import Notifications from '../components/notifications'
import {subscribe} from "../redux/slices/settings";
// @ts-ignore
import { NotificationContainer } from 'react-notifications'

export default function Settings() {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(subscribe({
            token: localStorage.getItem('notifications_token')
        }))
    }, [])

    return (
        <Container className='settings-component' style={{display: 'flex', justifyContent: 'center'}}>
            <div className='notif-cont' style={{
                marginTop: '10px'
            }}>
                <NotificationContainer />
            </div>

            <Notifications />

        </Container>
    )
}
